
import Vue from 'vue'
import { Categories } from '@/constants/elements'
import RectangleButton from '@/components/Buttons/RectangleButton.vue'
import { mapper } from '@/stores/store'

export default Vue.extend({
  name: 'HelloWorld',
  components: {
    RectangleButton,
  },
  computed: {
    ...mapper(['activeCategory']),
  },
  data() {
    return {
      categories: Categories,
    }
  },
  methods: {
    ...mapper(['setCategoryMenuOpen', 'setActiveCategory']),
    onClose(e: Event) {
      if (e.target !== e.currentTarget) return
      this.setCategoryMenuOpen(false)
    },
    onCategorySelected(category: Categories) {
      this.setActiveCategory(category)
    },
  },
})
